export default function auth ({ next, store }){
  if (!store.state.auth.user.aweber) {
    return next({
      name: 'dashboard',
    })
  }

  return next()
}